<template>
  <div class="login_page fillcontain">
    <transition name="form-fade" mode="in-out">
      <section class="form_contianer">
        <div class="log-face" v-if="switchhost == 'true'">
          <img src="../assets/xml_logo.png" alt="" />
        </div>
        <div class="log-face" v-if="switchhost == 'false'">
          <img src="../assets/dd_logo.png" alt="" />
        </div>
        <div class="log-face" v-if="switchhost == 'tongxiang'">
          <img src="../assets/tx_logo.png" alt="" />
        </div>
        <div class="log-face" v-if="switchhost == 'rental'">
          <img src="../assets/rental_login_logo.png" alt="" />
        </div>
        <div class="log-face" v-if="switchhost == 'zhongluo'">
          <img src="../assets/zhongluo_login_logo.png" alt="" />
        </div>
        <div class="log-face" v-if="switchhost == 'xianlvv2'||switchhost == 'ganzhou'">
          <img src="../assets/xml_logo.png" alt="" />
        </div>
        <div class="log-face" v-if="switchhost == 'kaifeng'">
          <img src="../assets/kaifeng_logo.png" alt="" />
        </div>
        <div class="manage_tip" v-if="switchhost == 'true'">闲驴系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'false'">朵朵系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'tongxiang'">桐乡系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'rental'">时租车系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'zhongluo'">北斗驴系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'xianlvv2'">闲驴两轮系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'ganzhou'">彪骑士系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'kaifeng'">骑达系统后台</div>
        <div class="bgbox">
          <div class="loginBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="手机号登录" name="first">
                <el-form :model="sendMsgForm">
                  <el-form-item>
                    <el-input ref="phoneLength" v-model="sendMsgForm.bindPhoneNum" placeholder="手机号"
                      style="width: 340px">
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="sendMsgForm.verificationCode" placeholder="短信验证码" style="width: 340px"><el-button
                        type="primary" style="
                          color: #fff;
                          background: #409eff;
                          margin-bottom: 5px;
                        " id="verification_code" slot="append" v-show="Verification"
                        :disabled="sendMsgForm.bindPhoneNum.length != 11">获取</el-button>
                      <button slot="append" type="text" disabled v-show="!Verification">
                        <span>{{ timer }}</span>s后重新获取
                      </button>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div id="verification" v-show="sendMsgForm.bindPhoneNum"></div>
                    <el-button @click="phoneSubmitForm('sendMsgForm')" class="submit_btn">登录</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="text" @click="helpBoxShow()">帮助？</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="账户密码登录" name="second">
                <el-form :model="loginForm" :rules="rules" ref="loginForm">
                  <el-form-item prop="username">
                    <el-input v-model="loginForm.username" style="width: 340px" placeholder="用户名"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input type="password" style="width: 340px" placeholder="密码"
                      v-model="loginForm.password"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <div id="captcha-element" v-show="this.loginForm.username && this.loginForm.password"></div>
                    <el-button id="captcha-button" style="background-color: #409eff;"  :disabled="!this.loginForm.username || !this.loginForm.password"
                      class="submit_btn">登录</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </section>
    </transition>

    <el-dialog title="登录方式变更说明" :visible.sync="helpShow" :close-on-press-escape="false" :show-close="false" width="25%"
      center>
      <span>1.登录方式已经支持手机号登录，账号若未绑定手机号，请联系管理员更新账号信息。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="helpShow = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>



<script>
// import { mapActions, mapState } from "vuex";
export default {
  data () {
    return {
      captcha: null,
      switchhost: "",
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      activeName: "first",
      sendMsgForm: {
        bindPhoneNum: '',
        verificationCode: ''
      },
      timer: 60,
      getDateNum: "",
      captchaVerifyParam: '',
      Verification: true, //通过v-show控制显示获取还是倒计时
      helpShow: false, // 帮助弹窗
      codesecret: "", // 验证码密文
    };
  },
  created () {
    console.log("cid", this.$route.query.cid)
  },
  beforeUnmount () {
    document.getElementById('aliyunCaptcha-mask').remove();
    document.getElementById('aliyunCaptcha-window-popup').remove();
  },
  mounted () {
    this.initAliyunCaptcha('first')
    this.switchhost = localStorage.getItem("total_switchhost");
    this.getCookie();
  },
  methods: {
    initAliyunCaptcha (name) {
      if (name == "second") {
        window.initAliyunCaptcha({
          SceneId: 'rwlbprfo', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
          prefix: 'kdysr1', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
          mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
          element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
          button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
          captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
          onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
          getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
          slideStyle: {
            width: 360,
            height: 40,
          }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
          language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        });
      } else {
        window.initAliyunCaptcha({
          SceneId: 'rwlbprfo', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
          prefix: 'kdysr1', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
          mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
          element: '#verification', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
          button: '#verification_code', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
          captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
          onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
          getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
          slideStyle: {
            width: 360,
            height: 40,
          }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
          language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        });
      }


    },
    getInstance (instance) {
      this.captcha = instance;
    },
    async captchaVerifyCallback (captchaVerifyParam) {
      // 1.向后端发起业务请求，获取验证码验证结果和业务结果
      // const result = await xxxx('http://您的业务请求地址', {
      //     captchaVerifyParam: captchaVerifyParam, // 验证码参数
      //     yourBizParam... // 业务参数
      // });
      // return {
      //  captchaResult: true, // 验证码验证是否通过，boolean类型，必选
      //  bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
      // }
      this.captchaVerifyParam = captchaVerifyParam
      let result = false
      if (this.activeName == 'second') {
        await this.submitForm('loginForm').then(res => {
          result = true
        }, err => {
          result = false
        })
      } else {
        await this.acquireCode().then(res => {
          result = true
        }, err => {
          result = false
        })
      }
      console.info(result)
      return {
        captchaResult: result,
        bizResult: true,
      }
    },
    async captchaVerifyCallback1 (captchaVerifyParam) {
      // 1.向后端发起业务请求，获取验证码验证结果和业务结果
      // const result = await xxxx('http://您的业务请求地址', {
      //     captchaVerifyParam: captchaVerifyParam, // 验证码参数
      //     yourBizParam... // 业务参数
      // });
      // return {
      //  captchaResult: true, // 验证码验证是否通过，boolean类型，必选
      //  bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
      // }
      // this.captchaVerifyParam = captchaVerifyParam
      // let result = false
      // await this.acquireCode().then(res => {
      //   result = true
      // }, err => {
      //   result = false
      // })

      // return {
      //   captchaResult: result,
      //   bizResult: true,
      // }
    },
    // 验证通过后调用
    onBizResultCallback () {
      console.log('onBizResultCallback');
    },
    async submitForm (formName) {
      return new Promise((resolve, reject) => {
        if (!this.loginForm.username) {
          this.$message({
            type: "warning",
            message: '请先输入用户名',
          });
          reject()
          return
        }
        if (!this.loginForm.password) {
          this.$message({
            type: "warning",
            message: '请先输入密码',
          });
          reject()
          return
        }
        if (!this.captchaVerifyParam) {
          reject()
          return
        }
        this.$opsaxios
          .post("/api/v1/member/user/login", {
            username: this.loginForm.username,
            password: this.loginForm.password,
            captchaverifyparam: this.captchaVerifyParam
          })
          .then((res) => {
            console.info(res);
            if (res.data.code == "0") {
              resolve()
              this.$message({
                type: "success",
                message: "登陆成功",
              });
              console.log("525252", res.data);
              localStorage.removeItem('total_token');
              localStorage.setItem("total_token", res.data.data.memberinfo.token);
              let _info = JSON.stringify(res.data.data.memberinfo);
              localStorage.setItem("total_userinfo", _info);
              let _datas = JSON.stringify(res.data.data.memu);
              localStorage.setItem("total_mnues", _datas);
              let paramss = { name: 'loginname', value: this.loginForm.username };
              var logindatas = Object.assign(paramss, { startTime: new Date().getTime() });
              localStorage.setItem("countdown", JSON.stringify(logindatas));
              this.getGaodeKey()
              setTimeout(() => {
                // bus.$emit("mnues", res.data.menu);
                this.$router.push({
                  path: "/main",
                });
                window.location.reload();
              }, 400);
            } else {
              if (res.data.message == '图形验证码错误') {
                reject()
              } else {
                resolve()
                this.$message({
                  type: "warning",
                  message: res.data.message,
                });
              }

            }
          });
      })

    },
    // 手机登录按钮
    phoneSubmitForm () {
      this.$opsaxios
        .post("/api/v1/member/user/phone/login", {
          phone: this.sendMsgForm.bindPhoneNum,
          code: this.sendMsgForm.verificationCode,
          codesecret: this.codesecret,
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.$message({
              type: "success",
              message: "登录成功！",
            });
            localStorage.removeItem('total_token');
            localStorage.setItem("total_ms_phone", this.sendMsgForm.bindPhoneNum);
            this.setCookie(this.sendMsgForm.bindPhoneNum, 7);
            localStorage.setItem("total_token", res.data.data.memberinfo.token);
            let _info = JSON.stringify(res.data.data.memberinfo);
            localStorage.setItem("total_userinfo", _info);
            let _datas = JSON.stringify(res.data.data.memu);
            localStorage.setItem("total_mnues", _datas);
            let paramss = { name: 'loginname', value: this.loginForm.username };
var logindatas = Object.assign(paramss, { startTime: new Date().getTime() });
              localStorage.setItem("countdown", JSON.stringify(logindatas));
              this.getGaodeKey()
              setTimeout(() => {
                // bus.$emit("mnues", res.data.menu);
                this.$router.push({
                  path: "/main",
                });
                window.location.reload();
              }, 400);
            } else {
              this.$message({
                type: "warning",
                message: res.data.message,
              });
            }
          });
    },
    // 设置cookie
    setCookie (c_phone, exdays) {
      var exdate = new Date(); // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        "userPhone" + "=" + c_phone + ";path=/;expires=" + exdate.toGMTString();
    },
    // 读取cookie
    getCookie () {
      var _this = this;
      let cookie = document.cookie
      if (cookie.length > 0) {
        var arr = cookie.split(";"); // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); // 再次切割
          if (arr2[0].replace(/\s*/g, "") === "userPhone") {
            _this.sendMsgForm.bindPhoneNum = arr2[1]; // 保存到保存数据的地方
          }
        }
      }
    },
    // 帮助盒子
    helpBoxShow () {
      this.helpShow = true;
    },
    // 获取验证码
    async acquireCode () {
      return new Promise((resolve, reject) => {
        if (this.sendMsgForm.bindPhoneNum == null) {
          this.$message({
            type: "error",
            message: "请输入手机号",
          });
          reject()
          return;
        } else if (this.$refs.phoneLength.value.length < 11) {
          this.$message({
            type: "error",
            message: "请补全手机号",
          });
          reject()
          return;
        } else if (this.$refs.phoneLength.value.length > 11) {
          this.$message({
            type: "error",
            message: "请输入正确的手机号",
          });
          reject()
          return;
        }
        // 获取当前时间
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        month = "" + month;
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        strDate = "" + strDate;
        this.getDateNum = year + month + strDate;
        this.$opsaxios
          .post("/api/v1/member/phone/sendcode", {
            phone: this.sendMsgForm.bindPhoneNum,
            md5code: this.$md5(this.sendMsgForm.bindPhoneNum + this.getDateNum),
            captchaverifyparam: this.captchaVerifyParam

          })
          .then((res) => {
            if (res.data.code == "0") {
              resolve()
              this.codesecret = res.data.data;
              this.$message({
                type: "success",
                message: "短信发送成功，请注意查收！",
              });
              this.btnDisable = true;
              this.Verification = false; //点击button改变v-show的状态
              let auth_timer = setInterval(() => {
                //定时器设置每秒递减
                this.timer--; //递减时间
                if (this.timer <= 0) {
                  this.Verification = true; //60s时间结束还原v-show状态并清除定时器
                  clearInterval(auth_timer);
                }
              }, 1000);
              this.timer = 60;
            } else {
              if (res.data.message == '图形验证码错误') {
                reject()
              } else {
                resolve()
                this.$message({
                  type: "warning",
                  message: res.data.message,
                });
              }
            }
          });
      })


    },
    handleClick (tab, event) {
      this.initAliyunCaptcha(tab.name)
      console.log(tab, event);
    },
    getGaodeKey () {
      this.$opsaxios
        .post("/api/v1/member/config")
        .then((res) => {
          if (res.data.code == "0" && res.data.data.gaode_key) {
            localStorage.setItem("total_gaode_key", res.data.data.gaode_key)
          }
        })
    },
  },
};
</script>


<style scoped>
.login_page {
  width: 100%;
  height: 100vh;
  /* text-align: center; */
  background: url("../assets/login_bg01.png") center center no-repeat;
}

.form_contianer {
  width: 320px;
  height: 360px;
  text-align: center;
  position: absolute;
  left: calc(50% - 160px);
  top: calc(50% - 300px);
}

.log-face img {
  width: 100px;
  height: auto;
  margin: 0 auto;
}

.loginBox {
  height: 250px;
  padding: 50px;
}

.bgbox {
  width: 520px;
  height: 396px;
  background: #fff;
  border-radius: 16px;
  position: absolute;
  left: -88px;
  top: 210px;
}

.manage_tip {
  color: #fff;
  font-size: 28px;
  margin: 25px 0;
}

.manage_tip p {
  font-size: 34px;
  padding: 20px 0;
}

.submit_btn {
  margin-top: 22px;
  border: none;
  color: #fff;
  width: 340px;
  font-size: 16px;
  background: #409eff;

}

.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 1s;
}

.form-fade-enter,
.form-fade-leave-active {
  transform: translate3d(0, -50px, 0);
  opacity: 0;
}

>>>.el-tabs__item.is-active {
  color: #409eff;
  cursor: pointer;
}

>>>.el-tabs__item {
  color: #acafb6;
}

>>>.el-input-group__append,
.el-input-group__prepend {
  background-color: #fff;
  border: 0;
  border-bottom: 1px solid #c0c4cc;
  border-radius: 0;
}

>>>.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 107px;
}

>>>.el-input__inner {
  border: 0;
  border-bottom: 1px solid #c0c4cc;
  border-radius: 0;
}

>>>.el-tabs__nav-wrap::after {
  background: #fff;
}

>>>.el-form-item__error {
  left: 39px;
}

>>>.el-dialog {
  margin-top: 19.7% !important;
  margin-left: 38% !important;
}

>>>.el-dialog__title {
  text-align: left !important;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue